import type { PageLoad } from './$types';
import { routesPagename } from '$lib/services/urls/routesPagename';

export const load = (async () => {
	return {
		zoiResultsStore: undefined,
		pagename: routesPagename.ROUTE_COST,
	};
}) satisfies PageLoad;
